import { Card, Label, LabelType } from '@yleisradio/areena-types';

type LabelFormatted = Label & {
  formatted: string;
};

export const findFormattedLabel = (
  selectedLabelType: LabelType,
  labels?: Label[]
) => {
  return labels?.find(
    (label): label is LabelFormatted =>
      selectedLabelType === label.type && !!label.formatted
  );
};

export const labelsOf = (
  selectedLabelTypes: LabelType | LabelType[],
  labels: Label[] | undefined,
  pickInOrder?: boolean
) => {
  if (labels) {
    const selected = ([] as string[]).concat(selectedLabelTypes);

    if (pickInOrder) {
      return selected.reduce((result, labelType) => {
        return result.concat(
          labels?.filter(
            (label): label is LabelFormatted =>
              labelType.includes(label.type) && !!label.formatted
          )
        );
      }, [] as LabelFormatted[]);
    }

    return labels.filter(
      (label): label is LabelFormatted =>
        selected.includes(label.type) && !!label.formatted
    );
  }

  return [];
};

export const getRawLabel = (
  card: Pick<Card, 'labels'>,
  labelType: LabelType
): string | undefined =>
  card.labels?.find(label => label.type === labelType)?.raw;

export const formatLabel = (card: Card, label: LabelType) =>
  findFormattedLabel(label, card.labels)?.formatted || '';
